import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="menu-item"
export default class extends Controller {

  static values = {
    close: Boolean
  }

  connect() {
    this.addListener()
  }

  disconnect() {
    this.removeListener()
  }

  addListener() {
    this.element.addEventListener("click", this.handleClick.bind(this))
  }

  removeListener() {
    this.element.removeEventListener("click", this.handleClick.bind(this))
  }

  handleClick(event) {
    if (this.closeValue === false) return
    const dropdown = event.target.closest("[data-dropdown-target='menu']")
    dropdown?.classList.add("hidden")
  }
  
}
